import FeaturesTable from './FeaturesTable'

export default FeaturesTable
